module.exports = __webpack_public_path__ + "img/default.45bbdc7a.png";